import { useMemo } from 'react';
import { useAuth } from '@/context/AuthContext';
import { usePermission } from '@/hooks/usePermission';
import { HELP_FEATURES } from '@/lib/helpContent';

/** Help features this user can actually use — plan, permission and role all honoured */
export function useAvailableHelpFeatures() {
  const { currentUser } = useAuth();
  const { can, hasFeature } = usePermission();

  return useMemo(() => HELP_FEATURES.filter(f => {
    if (f.planFeature && !hasFeature(f.planFeature)) return false;
    if (f.permission && !can(f.permission)) return false;
    if (f.audience === 'clinical') return !!currentUser?.doctor_id;
    if (f.audience === 'frontdesk') return currentUser?.role === 'staff' || currentUser?.role === 'admin';
    if (f.audience === 'admin') return currentUser?.role === 'admin';
    return true;
  }), [currentUser, can, hasFeature]);
}
